export function buildReportUrl(template, view, organizationId) {
  return template.replace('__REPORT_TYPE__', view).replace('__ORG_ID__', organizationId);
}
